import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import axios from "axios";
import { checkValidString } from "../../utils/helpers";
import Translation from "../../utils/Translation";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ContactDialog(props) {
  const dynamicState = useSelector((state) => state.dynamicConfig);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    mobile_number: "",
    msg: "",
  });
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ email: "" });

  const checkValidEmail = (val) => {
    if (checkValidString(val)) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(val)) {
        setErrors((prev) => ({
          ...prev,
          email: <Translation data="home.invalid_email" />,
        }));
        return false;
      } else {
        setErrors((prev) => ({ ...prev, email: "" }));
        return true;
      }
    }

    return false;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    setDisabled(
      checkValidString(form.full_name) &&
        checkValidEmail(form.email) &&
        checkValidString(form.msg) &&
        checkValidString(form.mobile_number)
        ? false
        : true
    );
  }, [form]);

  const handleSubmit = async () => {
    setDisabled(true);
    setLoading(true);
    try {
      
      await axios.post(`${dynamicState.prodApiServerBaseUrl}v1/contact_us/send_email`, form);
      props.handleClose(); // close modal
      handleClick(); // close message modal

      // reset value
      setForm({
        full_name: "",
        email: "",
        mobile_number: "",
        msg: "",
      });
      
    } catch (error) {
      alert(error.message);
      console.log(error)
    }
    setLoading(false);
    setDisabled(false);
  };

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <>
      <Dialog
        open={props.open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={props.handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <Translation data="layout.contact_us" />
        </DialogTitle>

        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            name="full_name"
            label={<Translation data="home.full_name" />}
            type="text"
            fullWidth
            variant="outlined"
            value={form.full_name}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            name="email"
            label={<Translation data="home.email" />}
            type="email"
            fullWidth
            variant="outlined"
            value={form.email}
            onChange={handleChange}
            helperText={errors.email}
            error={Boolean(errors.email)}  // <- This triggers red color
          />
          <TextField
            margin="dense"
            name="mobile_number"
            label={<Translation data="home.mobile" />}
            type="number"
            fullWidth
            variant="outlined"
            value={form.mobile_number}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            name="msg"
            label={<Translation data="home.message" />}
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            value={form.msg}
            onChange={handleChange}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={props.handleClose} disabled={loading}>
            <Translation data="home.cancel" />
          </Button>
          <Button onClick={handleSubmit} disabled={loading || disabled}>
            {loading ? (
              <CircularProgress size={20} />
            ) : (
              <Translation data="home.send" />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        className="seller-modal-msg"
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message="Message sent successfully!"
        action={action}
      />
    </>
  );
}

export default ContactDialog;
